export const types = {
    ACTIVATION_REQUEST: 'REGISTRATION_ACTIVATION_POST_REQUEST',
    ACTIVATION_SUCCESS: 'REGISTRATION_ACTIVATION_POST_SUCCESS',
    ACTIVATION_FAILURE: 'REGISTRATION_ACTIVATION_POST_FAILURE',

    SEND_ACTIVATION_MAIL_REQUEST: 'SEND_ACTIVATION_MAIL_REQUEST',
    SEND_ACTIVATION_MAIL_SUCCESS: 'SEND_ACTIVATION_MAIL_SUCCESS',
    SEND_ACTIVATION_MAIL_FAILURE: 'SEND_ACTIVATION_MAIL_FAILURE',
};